<script lang="ts">
  import { onMount } from 'svelte';
  import { writable } from 'svelte/store';
  import type { regions } from '@prisma/client';

  export let name: string | null = null;
  export let id: string | null = null;
  export let value: number | undefined = undefined;
  export let errorClass: string | null = null;

  const data = writable<regions[]>([]);

  onMount(() => {
    fetch('/api/regions')
      .then((res) => res.json())
      .then((res) => {
        data.set(res);
      });
  });

  const onChange = (e: Event) => {
    value = Number((e.target as HTMLSelectElement).value);
  };
</script>

<select
  {name}
  {id}
  {value}
  on:change={onChange}
  class={`form-select shadow-sm focus:ring-primary-500 focus:border-transparent focus:outline-none focus:ring-2 block w-full sm:text-sm border-gray-300 rounded-md ${
    $$props.class ?? ''
  } ${errorClass ?? ''}`}
>
  {#each $data as { id, name }}
    <option value={parseInt(id.toString())}>
      {name}
    </option>
  {/each}
</select>
